import {
  FETCH_STATUS_HISTORY_REQUEST,
  FETCH_STATUS_HISTORY_SUCCESS,
  FETCH_STATUS_HISTORY_FAILURE,
} from "./types";

import { fetchStatusHistory } from "../../services/statusHistoryService";


export const fetchStatusHistoryRequest = () => ({
  type: FETCH_STATUS_HISTORY_REQUEST,
});

export const fetchStatusHistorySuccess = (data) => ({
  type: FETCH_STATUS_HISTORY_SUCCESS,
  payload: data,
});

export const fetchStatusHistoryFailure = (error) => ({
  type: FETCH_STATUS_HISTORY_FAILURE,
  payload: error,
});

// Thunk
export const fetchStatusHistoryAction =
  (itemType = null, itemId = null) =>
  async (dispatch) => {
    dispatch(fetchStatusHistoryRequest());

    try {
      const response = await fetchStatusHistory(itemType, itemId);

      if (response.error) {
        dispatch(fetchStatusHistoryFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchStatusHistorySuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      const errMsg =
        error.message || "Failed to fetch status history";
      dispatch(fetchStatusHistoryFailure(errMsg));
      return { success: false, error: errMsg };
    }
  };

